import React from 'react'
import faro from './faro.png'
import leftRocks from './left-rocks.png'
import righttRocks from './right-rocks.png'
import { NavLink } from 'react-router-dom'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
//styles
import styles from './index.module.css'

const NotFoundPage = () => {
  const _state = useSelector(state => state.drawerLeft)

  return (
    <Box
      component="div"
      style={{
        marginLeft: _state.open ? _state.drawerWidthMin : 0,
        height: _state.contentBox,
        width: 'inherit',
        marginTop: _state.drawerHeight,
      }}>
      <div className={styles.container}>
        <div className={styles.faroContainer}>
          <div className={styles.h1}>
            <div>
              No existe contenido para esta la dirección. {`\n`}
              <NavLink to="/"> Regrese a página de Inicio</NavLink>
            </div>
          </div>
          <div className={styles.h2}></div>
          <img className={styles.faro} src={faro} alt="" />
          <h1>404</h1>
        </div>

        <div className={styles.rocks}>
          <img className={styles.rock} src={leftRocks} alt="" />
          <img className={styles.rock} src={righttRocks} alt="" />
        </div>
      </div>
    </Box>
  )
}

export default NotFoundPage
